export default __webpack_public_path__ + "static/media/ing-1.22c0916f.png";